<template>
  <div class="preview-survey" id="survey-scroller">
    <template v-if="!error && question">
      <section class="section">
        <div class="columns page-wrap is-centered is-vcentered">
          <transition mode="out-in" name="page-component">
            <component
                :is="`Q${question.type}`"
                :lang="lang"
                :question="question"
                :show-question-code="showQuestionCode"
                :show-answer-code="showAnswerCode"
                :value="changes"
                @input="onChange"
            ></component>
          </transition>
        </div>
      </section>
    </template>
    <ErrorMessage :error="error"></ErrorMessage>
  </div>
</template>

<script>
import { getSurveyQuestion } from '@/api/response'
import { QuestionTypeComponentsMixin } from '@/mixins/question-type-components'
import { ErrorHandlerMixin } from '@/mixins/error-handler'
import { LocaleSwitchingMixin } from '@/mixins/locale-switching'
import { PreviewMixin } from '@/mixins/preview'

export default {
  name: 'PreviewQuestion',
  mixins: [
    QuestionTypeComponentsMixin,
    ErrorHandlerMixin,
    LocaleSwitchingMixin,
    PreviewMixin,
  ],
  data () {
    return {
      question: null,
    }
  },
  methods: {
    async init () {
      this.error = null
      const loadingComponent = this.$buefy.loading.open()
      try {
        const { params: { code, questionCode } } = this.$route
        if (code && questionCode) {
          await this.getSurvey()
          const { data: { data } } = await getSurveyQuestion(code, questionCode)
          this.question = data
        }
      } catch (error) {
        this.errorHandler(error)
      } finally {
        loadingComponent.close()
      }
    },
  },
  created () {
    this.init()
  }
}
</script>
